import styled, { keyframes } from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  padding: 1rem 1.6rem;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const Section = styled.div`
  margin-bottom: 3rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${Colors?.text_Color_1};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
`;

export const TitleDot = styled.span`
  width: 8px;
  height: 8px;
  background: ${Colors?.ftColor3};
  border-radius: 50%;
  display: inline-block;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  grid-auto-rows: 1fr;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ComunicadoCard = styled.div`
  /* background: ${props => (props.destaque ? Colors?.bgColor4 : Colors?.bgColor1)}; */
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px ${Colors?.bgCardColor};
  border: 1px solid ${Colors?.ftColor3}50;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 280px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${Colors?.bgCardColor};
  }
`;

export const CardHeader = styled.div`
  margin-bottom: 0.8rem;
`;

export const DestaqueBadge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 80px 80px 0;
  border-color: transparent ${Colors?.ftColor3}80 transparent transparent;
`;

export const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${Colors?.text_Color_1};
  margin: 0;
  line-height: 1.4;
`;

export const CardDescription = styled.div`
  font-size: 0.95rem;
  color: ${Colors?.ftColor2};
  font-weight: 300;
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 4.56rem;
  flex-shrink: 0;

  * {
    margin: 0 !important;
    padding: 0 !important;
    font-size: inherit !important;
    line-height: inherit !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit !important;
    font-weight: inherit !important;
  }

  p {
    display: inline;
  }

  img {
    display: none;
  }

  br {
    content: ' ';
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.8rem;
  background: ${props => (props.isPdf ? Colors?.Color12 : props.cor)};
  color: ${props => (props.isPdf ? Colors?.ftColor1 : Colors?.ftColor4)};
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid ${props => (props.isPdf ? 'transparent' : 'transparent')};

  span {
    font-size: 0.9rem;
  }
`;

// Badges no cabeçalho do card (ex: "1 anexo")
// export const HeaderBadges = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   margin-bottom: 0.5rem;
//   flex-wrap: wrap;
// `;

// export const Badge = styled.span`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.35rem;
//   padding: 0.25rem 0.6rem;
//   border-radius: 999px;
//   font-size: 0.75rem;
//   font-weight: 700;
//   background: ${Colors?.bgButton2};
//   color: ${Colors?.ftColor1};
//   border: 1px solid ${Colors?.Border_Color_1};
// `;

// export const AttachmentBadge = styled(Badge)`
//   background: rgba(82, 180, 222, 0.15);
//   border-color: ${Colors?.ftColor3}50;
//   color: ${Colors?.text_Color_1};
// `;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid ${Colors?.Border_Color_1};
  margin-top: auto;
`;

export const DateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: ${Colors?.ftColor2};

  span {
    font-size: 1rem;
  }
`;

export const ViewStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: ${Colors?.ftColor2};

  span {
    font-size: 1rem;
  }
`;

export const ComunicadosList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  grid-auto-rows: 1fr;
  align-items: stretch;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ComunicadoItem = styled.div`
  /* background: ${Colors?.bgColor1}; */
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px ${Colors?.bgCardColor};
  border: 1px solid ${Colors?.Border_Color_1};
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 280px;
  min-width: 0;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${Colors?.bgCardColor};
  }
`;

export const ItemContent = styled.div`
  /* margin-bottom: 1rem; */
  /* flex: 1; */

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-width: 0;
  overflow: hidden;
`;

export const ItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
`;

export const ItemTitle = styled.h4`
  font-size: 1.2rem;
  font-weight: 800;
  color: ${Colors?.text_Color_1};
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const NovoBadge = styled.span`
  color: ${Colors?.ftColor3};
  font-size: 1.2rem;
`;

export const ItemDescription = styled.div`
  font-size: 0.8rem;
  color: ${Colors?.ftColor2}90;
  line-height: 1.6;
  margin: 0 0 1rem 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 3.84rem;
  flex-shrink: 0;

  * {
    margin: 0 !important;
    padding: 0 !important;
    font-size: inherit !important;
    line-height: inherit !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit !important;
    font-weight: inherit !important;
  }

  p {
    display: inline;
  }

  img {
    display: none;
  }

  br {
    content: ' ';
  }
`;

export const ItemFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid ${Colors?.Border_Color_1};
  margin-top: 1rem;
`;

export const VerMaisButton = styled.button`
  background: transparent;
  border: none;
  color: ${Colors?.ftColor1};
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem 1rem;
  transition: color 0.2s ease;

  &:hover {
    color: ${Colors?.ftColor3};
    text-decoration: underline;
  }
`;

// Birthday Cake Icon animation
const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
`;

export const CakeIcon = styled.div`
  font-size: 2rem;
  animation: ${float} 2s ease-in-out infinite;
  will-change: transform;
`;

// Header Styles
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${Colors?.Border_Color_1};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const HeaderTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  /* color: ${Colors?.ftColor1}; */
  color: ${Colors?.text_Color_1};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;

  &::before {
    content: '🔔';
    font-size: 1.5rem;
  }
`;

export const HeaderButton = styled.button`
  padding: 0.6rem 1rem;
  background: ${Colors?.bgButton1};
  color: ${Colors?.ftColor4};
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const HeaderDate = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.9rem;
  background: ${Colors?.bgCardColor};
  color: ${Colors?.text_Color_1};
  border: 1px solid ${Colors?.Border_Color_1};
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 600;
`;

// Modal Styles
export const ModalContent = styled.div`
  background: ${Colors?.Color13};
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  border: 1px solid ${Colors?.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem;
  border-bottom: 1px solid ${Colors?.Border_Color_1};
  /* background: ${props => (props.secondary ? Colors?.bgButton2 : Colors?.bgButton1)}; */
`;

export const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${Colors?.text_Color_1};
  margin: 0;
`;

export const ModalCloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: ${Colors?.ftColor2};
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;

  &:hover {
    color: ${Colors?.ftColor1};
    background: ${Colors?.bgCardColor};
  }
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  color: ${Colors?.text_Color_1};
  background: ${Colors?.Color13};
  max-height: calc(90vh - 180px);
  overflow-y: auto;

  p {
    font-size: 1rem;
    line-height: 1.6;
    /* margin: 0 0 0.5rem 0; */
    color: ${Colors?.text_Color_1};
    font-weight: 300;
  }

  ul,
  ol {
    /* margin: 0 0 0.5rem 0; */
    padding-left: 1.5rem;
    color: ${Colors?.text_Color_1};
    font-size: 1rem;
  }

  li {
    /* margin-bottom: 0.25rem; */
    line-height: 1.6;
    color: ${Colors?.text_Color_1};
    font-size: 1rem;
  }

  ul li {
    list-style-type: disc;
  }

  ol li {
    list-style-type: decimal;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${Colors?.text_Color_1};
    margin: 1.5rem 0 0.75rem 0;
    font-weight: 600;
  }

  /* Primeiro heading não precisa de margem superior */
  h1:first-child,
  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child,
  h6:first-child {
    margin-top: 0;
  }

  h1 {
    font-size: 2rem;
  }
  h2 {
    font-size: 1.5rem;
    margin-top: 2rem;
  }
  h3 {
    font-size: 1.25rem;
  }

  /* Linha horizontal */
  hr {
    border: none;
    border-top: 2px solid ${Colors?.Border_Color_1 || '#ddd'};
    margin: 2rem 0;
  }

  strong {
    font-weight: 700;
    color: ${Colors?.text_Color_1};
  }

  em {
    font-style: italic;
  }

  a {
    color: ${Colors?.ftColor3};
    text-decoration: underline;
  }

  /* Estilos específicos para imagens do TipTap */
  img,
  .tiptap-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 1em auto;
    display: block;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: zoom-in;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.02);
    }
  }

  /* Estilos para links do TipTap */
  .tiptap-link {
    color: ${Colors?.Color4 || '#4285f4'};
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  /* Estilos para blockquote do TipTap */
  blockquote {
    border-left: 4px solid ${Colors?.Color4 || '#4285f4'};
    padding-left: 16px;
    margin: 1em 0;
    color: ${Colors?.text_Color_2 || '#666'};
    font-style: italic;
  }

  /* Estilos para código do TipTap */
  code {
    background: ${Colors?.Color12 || 'rgba(110, 118, 129, 0.4)'};
    padding: 3px 6px;
    border-radius: 4px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.75em;
    color: ${Colors?.Color9 || '#e8eaed'};
    border: 1px solid ${Colors?.Color5 || 'rgba(255, 255, 255, 0.1)'};
  }

  pre {
    background: ${Colors?.Color12 || 'rgba(110, 118, 129, 0.4)'};
    padding: 12px;
    border-radius: 6px;
    overflow-x: auto;
    margin: 1em 0;
    border: 1px solid ${Colors?.Color5 || 'rgba(255, 255, 255, 0.1)'};
    font-size: 0.85em;

    code {
      background: transparent;
      padding: 0;
      border: none;
      font-size: 0.8em;
    }
  }

  /* Linha horizontal do TipTap */
  hr {
    border: none;
    border-top: 2px solid ${Colors?.Border_Color_1 || '#ddd'};
    margin: 2em 0;
  }

  label {
    color: ${Colors?.text_Color_1};
    font-weight: 500;
  }

  input,
  textarea {
    background: ${Colors?.Input_Color_1};
    color: ${Colors?.ftColor1};
    border: 1px solid ${Colors?.Border_Color_1};

    &::placeholder {
      color: ${Colors?.ftColor5};
    }

    &:focus {
      outline: none;
      border-color: ${Colors?.ftColor3};
    }
  }
`;

// Buttons styled in GMUD style
export const AddButton = styled.button`
  background: #ffffff10;
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  padding: 6px 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.text_Color_1};
  font-size: 0.85rem;
  font-weight: 400;
  cursor: pointer;
  transition: background 300ms ease-in-out;

  &:hover {
    background: #ffffff20;
  }
  &:active {
    background: #ffffff30;
  }
  &:focus {
    box-shadow: 0 0 0 2px ${Colors.primary_Color_1};
  }
  &:disabled {
    background: #ffffff05;
    color: #ffffff50;
    cursor: not-allowed;
  }
`;

export const DeleteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 300;
  cursor: pointer;
  height: 28px;
  width: 28px;
  transition: background 0.3s, border 0.3s;

  &:hover {
    background: #ffffff10;
    border: 1px solid #ffffff25;
  }
  &:active {
    background: #ffffff10;
    border: 1px solid #ffffff25;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid ${Colors?.Border_Color_1};
  background: ${Colors?.Color8};
`;

export const ModalButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: ${props => (props.secondary ? 'transparent' : Colors?.bgButton1)};
  border: 1px solid ${props => (props.secondary ? Colors?.Border_Color_1 : 'transparent')};
  color: ${props => (props.secondary ? Colors?.Color9 : Colors?.ftColor4)};
  /* border: none; */
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// File Input Styles
export const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FileInputLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: ${Colors?.bgButton2};
  color: ${Colors?.ftColor1};
  border: 1px solid ${Colors?.Border_Color_1};
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;

  &:hover {
    background: ${Colors?.bgCardColor};
    transform: translateY(-1px);
  }
`;

export const FileInputInfo = styled.span`
  font-size: 0.9rem;
  color: ${Colors?.ftColor2};
  padding: 0.5rem;
`;

export const FileDropZone = styled.div`
  border: 2px dashed ${props => (props.isDragging ? Colors?.ftColor3 : Colors?.Border_Color_1)};
  border-radius: 12px;
  padding: 1rem;
  background: ${props => (props.isDragging ? Colors?.bgCardColor : Colors?.Color8)};
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${Colors?.ftColor3};
    background: ${Colors?.bgCardColor};
  }
`;

export const FileDropZoneContent = styled.div`
  text-align: center;
  color: ${Colors?.ftColor1};
  width: 100%;
  cursor: pointer;
  user-select: none;
`;

export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  background: ${Colors?.Color13};
  border-radius: 8px;
  border: 1px solid ${Colors?.Border_Color_1};
`;

export const FilePreviewIcon = styled.div`
  font-size: 2.5rem;
  flex-shrink: 0;
`;

export const FilePreviewInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FilePreviewName = styled.div`
  font-size: 0.95rem;
  font-weight: 500;
  color: ${Colors?.ftColor1};
  margin-bottom: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FilePreviewSize = styled.div`
  font-size: 0.85rem;
  color: ${Colors?.ftColor2};
`;

export const RemoveFileButton = styled.button`
  background: transparent;
  border: none;
  color: ${Colors?.ftColor2};
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: ${Colors?.bgCardColor};
    color: ${Colors?.ftColor1};
  }
`;

export const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.5rem;
  background: ${Colors?.bgButton1};
  color: ${Colors?.ftColor4};
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// Radio and Checkbox Group Styles
export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const RadioGroupLabel = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 500;
  color: ${Colors?.ftColor1};
  margin-bottom: 0.5rem;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CheckboxGroupLabel = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 500;
  color: ${Colors?.ftColor1};
  margin-bottom: 0.5rem;
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// Indicador de comunicado não lido
export const UnreadIndicator = styled.div`
  position: absolute;
  top: -2.5px;
  right: -2.5px;
  width: 10px;
  height: 10px;
  background: #ff4444;
  border-radius: 50%;
  /* border: 2px solid white; */
  z-index: 10;

  /* Animação pulsante para chamar atenção */
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

// Container com posição relativa para o indicador
export const ComunicadoItemContainer = styled.div`
  position: relative;
  height: 100%;
  min-width: 0;
`;

// Skeleton Loading
export const SkeletonCard = styled.div`
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px ${Colors?.bgCardColor};
  border: 1px solid ${Colors?.Border_Color_1};
  display: flex;
  flex-direction: column;
  height: 100%;

  .skeleton {
    background: ${localStorage.getItem('tema') == 'E'
      ? 'linear-gradient(90deg, #ffffff15 25%, #ffffff05 50%, #ffffff10 75%)'
      : 'linear-gradient(90deg, #6796cf50 25%, #6796cf25 50%, #6796cf50 75%)'};
    background-size: 200% 100%;
    animation: skeleton-loading 4s infinite linear;
    border-radius: 4px;
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const SkeletonItem = styled(SkeletonCard)`
  /* min-height: 280px; */
`;
